export default {
    all: { method: 'GET', url: 'servico/all' },
    active: { method: 'GET', url: 'servico/active' },
    get: { method: 'GET', url: 'servico/get{/id}' },
    create: { method: 'POST', url: 'servico' },
    update: { method: 'PUT', url: 'servico' },
    inactive: { method: 'DELETE', url: 'servico{/id}' },
};